import classNames from 'classnames/bind';
import { useState } from 'react';
import useOffClick from '@flight-workspace/common-client/src/hooks/useOffClick';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  children?: JSX.Element;
}

export default function PromotionBadge({ children }: IProps) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useOffClick(() => setIsOpen(false), { stopPropagation: true });
  return (
    <span className={cx('promotionBadge')}>
      <i
        className={cx('badge')}
        aria-expanded={isOpen}
        onClick={() => setIsOpen(() => true)}
      >
        이벤트혜택
      </i>
      {children && (
        <p className={cx('layer')} ref={isOpen ? ref : null}>
          <span className={cx('txt')}>{children}</span>
        </p>
      )}
    </span>
  );
}
